import { PAGE_ROUTES } from '@/components/nav/utils/url-builders';
import { isPageActive } from '@/lib/is-page-active';
import {
  dealStore,
  primaryCustomerStore,
  userStore,
  vehicleFromIndexerStore,
  vehicleListingStore,
} from '@/models/stores';
import { runInAction } from 'mobx';
import { useEffect } from 'react';

const useContractQueuePageHydrateLocal = () => {
  const isContractQueuePageActive = isPageActive(PAGE_ROUTES.CONTRACT_QUEUE);
  const shouldRun = isContractQueuePageActive;

  useEffect(() => {
    if (!shouldRun) {
      return;
    }

    const hydrateContractQueue = async () => {
      // Load active deals and related entities from IndexedDB
      // Contract queue shows deals grouped by contract-related stages
      await Promise.all([
        dealStore.hydrateActiveDeals(),
        primaryCustomerStore.hydrateLocal(),
        vehicleFromIndexerStore.hydrateLocal(),
        vehicleListingStore.hydrateLocal(),
        userStore.hydrateLocal(),
      ]);
    };

    runInAction(async () => {
      await hydrateContractQueue();
    });
  }, [shouldRun]);
};

export default useContractQueuePageHydrateLocal;
